import { AbstractControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * Error-state matcher for dynamic form controls.
 *
 * The default Material matcher keys off `control.invalid`, but a disabled
 * `FormControl` always reports status `DISABLED` (never `INVALID`) and is
 * excluded from validation, so a disabled, required, blank field never enters
 * the error state and shows no red styling.
 *
 * `applyInvalidRule()` sets `{ invalid: true }` via `setErrors()` and marks the
 * control touched even while disabled, and those land on `control.errors`
 * regardless of disabled status. Keying off `errors` (instead of `invalid`)
 * lets disabled controls surface the same error style as enabled ones, while
 * remaining equivalent to the default behavior for enabled controls.
 */
export class DynamicControlErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: AbstractControl | null): boolean {
    return !!(control && control.errors && control.touched);
  }
}

export const DYNAMIC_ERROR_STATE_MATCHER = new DynamicControlErrorStateMatcher();
